import { render, staticRenderFns } from "./ContentColorUpReview.vue?vue&type=template&id=4c11b6a6&scoped=true&"
import script from "./ContentColorUpReview.vue?vue&type=script&lang=js&"
export * from "./ContentColorUpReview.vue?vue&type=script&lang=js&"
import style0 from "./ContentColorUpReview.vue?vue&type=style&index=0&id=4c11b6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c11b6a6",
  null
  
)

export default component.exports